import React, { useMemo } from 'react';
import { useWindowSize } from '@yme/common/hooks';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { formatDistance } from '@yme/utils/common';
import { DistanceLabel } from './DistanceLabel';
import { getDealerAddress } from './helpers';
import { DealerDataStyled, TableHeaderStyled, TableLabelStyled } from './styled';
export function DealerTable({ isRightToLeft, data, isGBCountyRoot, }) {
    const { isMobileView } = useWindowSize();
    const { t } = useTranslation();
    const { distance, telephoneNumbers, addressLines } = data;
    const addressLine = getDealerAddress(data, isGBCountyRoot);
    const isDataExists = telephoneNumbers[0] || addressLine || (isMobileView && distance);
    const distanceRow = useMemo(() => (React.createElement(DistanceLabel, { isRightToLeft: isRightToLeft, distance: distance, label: formatDistance(distance, t) })), [distance, isRightToLeft, t]);
    if (!isDataExists) {
        return null;
    }
    return (React.createElement(FlexWrapper, { gap: "24px" },
        React.createElement(DealerDataStyled, { isRightToLeft: isRightToLeft },
            React.createElement("tbody", null,
                isMobileView && (React.createElement("tr", null,
                    React.createElement(TableHeaderStyled, { isRightToLeft: isRightToLeft }, t('common_preferredDealerDealerCardDistance_label')),
                    React.createElement(TableLabelStyled, null, distanceRow))),
                telephoneNumbers[0] && (React.createElement("tr", null,
                    React.createElement(TableHeaderStyled, { isRightToLeft: isRightToLeft }, t('common_preferredDealerDealerCardPhone_label')),
                    React.createElement(TableLabelStyled, null, telephoneNumbers[0]))),
                addressLines[0] && (React.createElement("tr", null,
                    React.createElement(TableHeaderStyled, { isRightToLeft: isRightToLeft }, t('common_preferredDealerDealerCardAddress_label')),
                    React.createElement(TableLabelStyled, null, addressLine)))))));
}
